module.exports = __webpack_public_path__ + "static/media/number-icon.9f0c4321.svg";